/** Milliseconds from VITE_QUOTE_SAVE_MIN_INTERVAL_MS; anything but a finite non-negative number is 0. */
export const parseSaveMinIntervalMs = (raw: unknown): number => {
    if (raw === undefined || raw === null || raw === '') return 0;
    const value = Number(raw);
    return Number.isFinite(value) && value >= 0 ? value : 0;
};
